import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    props: true
  },
  {
    path: "/about-us",
    name: "about-us",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/topLevel.vue"),
    props: true
  },
  {
    path: "/our-services",
    name: "our-services",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/topLevel.vue"),
    props: true
  },
  {
    path: "/case-studies",
    name: "case-studies",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/topLevel.vue"),
    props: true
  },
  {
    path: "/contact-us",
    name: "contact-us",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/topLevel.vue"),
    props: true
  },
  {
    path: "/careers",
    name: "careers",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/topLevel.vue"),
    props: true
  },
  {
    path: "/case-studies/:id",
    name: "case",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/single.vue"),
    props: true
  },

];

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
